<template>
  <div class="vue iw-reward-form">

    <LoaderOverlay v-if="loading"/>

    <div v-if="formAvailable">
      <div class="bg-primary text-white p-4">
        <div class="container text-center">
          <h3>Hai vinto il concorso <span class="text-secondary">{{ current_contest.title }}</span> e hai accettato il
            tuo premio</h3>
        </div>
      </div>

      <div class="p-4">

        <div v-if="current_state == 'form'">
          <div class="container">

            <h2 class="text-center font-weight-bold my-5 text-dark">
              {{ __('Per ricevere il premio inserisci i tuoi dati') }}</h2>


            <div class="form-timparty">

              <!-- MAIN FORM - BEGIN -->
              <div class="row">
                <div class="col-sm-12 mb-3" v-if="!form_sections.shipping">
                  <span style="font-size: 0.75rem">Ti ricordiamo che i dati che inserirai nei campi “Nome” e “Città” saranno riportati pubblicamente nell’elenco dei vincitori del concorso, come previsto dall’<a href="https://www.timparty.tim.it/sites/default/files/2023-11/Info_Privacy_GAMES_WEEK_202311.pdf" target="_blank">Informativa Privacy</a>. Ti raccomandiamo quindi di inserire nel campo “Nome” solo il tuo nome proprio e nel campo “Città” solo la tua città di residenza.</span>
                </div>
                <div class="col-sm-6">
                  <div :class="'form-group ' + (validation_errors.firstName ? 'has-error' : '')">
                    <label for="firstName">{{ __('Nome') }}*</label>
                    <input id="firstName" type="text" class="form-control" v-model="userdata.firstName">
                  </div>
                </div>
                <div class="col-sm-6" v-if="form_sections.shipping">
                  <div :class="'form-group ' + (validation_errors.lastName ? 'has-error' : '')">
                    <label for="lastName">{{ __('Cognome') }}*</label>
                    <input id="lastName" type="text" class="form-control" v-model="userdata.lastName">
                  </div>
                </div>

                <div class="col-sm-6">
                  <div :class="'form-group ' + (validation_errors.city ? 'has-error' : '')">
                    <label for="city">{{ __('Città') }}*</label>
                    <input id="city" type="text" class="form-control" v-model="userdata.city">
                  </div>
                </div>
                <div class="col-sm-3" v-if="form_sections.shipping">
                  <div :class="'form-group ' + (validation_errors.zipCode ? 'has-error' : '')">
                    <label for="zipCode">{{ __('CAP') }}*</label>
                    <input id="zipCode" type="text" class="form-control" maxlength="5" v-model="userdata.zipCode">
                  </div>
                </div>
                <div class="col-sm-3" v-if="form_sections.shipping">
                  <div :class="'form-group ' + (validation_errors.province ? 'has-error' : '')">
                    <label for="province">{{ __('Provincia') }}*</label>
                    <select id="province" class="form-control" v-model="userdata.province"
                            v-if="italian_districts && userdata.country == 'IT'">
                      <option v-for="p in italian_districts" v-bind:key="p.sigla" :value="p.sigla">{{ p.nome }}</option>
                    </select>
                    <input v-else type="text" class="form-control" v-model="userdata.province">

                  </div>
                </div>
                <!--
                <div class="col-sm-4" v-if="countries">
                  <div :class="'form-group ' + (validation_errors.country ? 'has-error' : '')">
                    <label for="">Stato</label>
                    <select class="form-control" v-model="userdata.country">
                      <option v-for="c in countries" v-bind:key="c.code" :value="c.code">{{ c.name }}</option>
                    </select>
                  </div>
                </div>
                -->
              </div>


              <div class="row" v-if="form_sections.shipping">
                <div class="col-sm-9">
                  <div :class="'form-group ' + (validation_errors.address ? 'has-error' : '')">
                    <label for="address">{{ __('Indirizzo') }}*</label>
                    <input id="address" type="text" class="form-control" v-model="userdata.address">
                  </div>
                </div>
              </div>


              <div class="row">
                <div :class="( form_sections.shipping ? 'col-sm-6' : 'col-sm-12')">
                  <div :class="'form-group ' + (validation_errors.email ? 'has-error' : '')">
                    <label for="email">{{ __('Email') }}*</label>
                    <input id="email" type="text" class="form-control" v-model.trim="userdata.email">
                  </div>
                </div>
                <div class="col-sm-6" v-if="form_sections.shipping">
                  <div :class="'form-group '">
                    <label for="phone">Telefono</label>
                    <input id="phone" type="text" class="form-control" v-model="userdata.phone">
                  </div>
                </div>
              </div>

              <!--
              <div class="row">
                <div class="col-sm-6">
                  <div :class="'form-group ' + (validation_errors.careOf ? 'has-error' : '')">
                    <label for="">Presso</label>
                    <input type="text" class="form-control" v-model="userdata.careOf">
                  </div>
                </div>
                <div class="col-sm-6">
                  <div :class="'form-group ' + (validation_errors.deliveryNote ? 'has-error' : '')">
                    <label for="">Note di consegna</label>
                    <input type="text" class="form-control" v-model="userdata.deliveryNote">
                  </div>
                </div>
              </div>
              -->
              <!-- MAIN FORM - END -->


              <!-- ID DOCUMENT - BEGIN -->
              <div v-if="idRequired">

                <h4>{{ __('Documento di identità') }}</h4>
                <p>{{
                    __('Per ricevere il premio è necessario fornire alcuni dati relativi a un documento d\'identità valido del vincitore')
                  }}</p>

                <div class="row">
                  <div class="col-sm-4">
                    <div :class="'form-group ' + (validation_errors.id_name ? 'has-error' : '')">
                      <label for="id_name">{{ __('Nome') }}*</label>
                      <input id="id_name" type="text" class="form-control" v-model="userdata.id.name">
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :class="'form-group ' + (validation_errors.id_surname ? 'has-error' : '')">
                      <label for="id_surname">{{ __('Cognome') }}*</label>
                      <input id="id_surname" type="text" class="form-control" v-model="userdata.id.surname">
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :class="'form-group ' + (validation_errors.id_documentNumber ? 'has-error' : '')">
                      <label for="id_documentNumber">{{ __('Numero del documento') }}*</label>
                      <input id="id_documentNumber" type="text" class="form-control"
                             v-model="userdata.id.documentNumber">
                    </div>
                  </div>


                  <div class="col-sm-3">
                    <div :class="'form-group ' + (validation_errors.id_documentType ? 'has-error' : '')">
                      <label for="id_documentType">{{ __('Tipo di documento') }}*</label>
                      <select id="id_documentType" class="form-control" v-model="userdata.id.documentType">
                        <option v-for="id_type in id_types" v-bind:key="id_type.code" :value="id_type.code">
                          {{ id_type.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="'form-group ' + (validation_errors.id_municipalityRelease ? 'has-error' : '')">
                      <label for="id_municipalityRelease">{{ __('Rilasciato da') }}*</label>
                      <input id="id_municipalityRelease" type="text" class="form-control"
                             v-model="userdata.id.municipalityRelease">
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="'form-group ' + (validation_errors.id_releaseDate ? 'has-error' : '')">
                      <label for="id_releaseDate">{{ __('Data di rilascio') }}*</label>
                      <input id="id_releaseDate" type="date" class="form-control" v-model="userdata.id.releaseDate">
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="'form-group ' + (validation_errors.id_validityDate ? 'has-error' : '')">
                      <label for="id_validityDate">{{ __('Valido fino al') }}*</label>
                      <input id="id_validityDate" type="date" class="form-control" v-model="userdata.id.validityDate">
                    </div>
                  </div>
                </div>
              </div>
              <!-- ID DOCUMENT - END -->


              <!-- PRIVACY CONSENT - BEGIN -->
              <div :class="'form-group ' + (validation_errors.privacy_consent ? 'has-error' : '')">
                <div class="custom-control custom-checkbox p-4 mt-4">
                  <input type="checkbox" class="custom-control-input" id="privacy_consent"
                         v-model="userdata.privacy_consent">
                  <label class="custom-control-label" for="privacy_consent">Consenso al <a class="font-weight-bold"
                                                                                           :href="current_contest.privacyInfo"
                                                                                           target="_blank">trattamento
                    dei dati personali</a></label>
                </div>
              </div>
              <!-- PRIVACY CONSENT - END -->


              <!-- ID ATTACHMENT / DEPRECATED - BEGIN -->
              <!--
              <div v-if="idRequired" :class="'form-group ' + (validation_errors.id_attachment ? 'has-error' : '')">
                  <div class="p-4 mt-4">

                    <div v-if="idFilename">
                      <button @click.prevent="idFilename = null">X</button>{{ idFilename }}
                    </div>
                    <div v-else>
                      <input id="id-attachment-input" class="d-none" type="file" @change="handleFileChange">
                      <a href="#" @click.prevent="triggerFileInput">{{ __('Carica il documento d’identità (.pdf, .jpg, .png, max 5Mb)') }}</a>
                    </div>


                  </div>
              </div>
              -->
              <!-- ID ATTACHMENT / DEPRECATED - END -->


              <div class="form-actions mt-4 text-center">
                <button class="btn btn-primary btn-lg" @click.prevent="submitForm">{{ __('INVIA') }}</button>
              </div>

            </div>

          </div>
        </div>
        <div v-else-if="current_state == 'result'" class="text-center">
          Dati inviati correttamente
        </div>

        <div v-else-if="!loading" class="text-center">Stato non gestito</div>


      </div>
    </div>


    <div v-else class="bg-primary p-5 text-center">
      Nessun premio disponibile per la redenzione
    </div>


    <div class="bg-warning p-4" v-if="environment == 'dev'">
      <div class="container">
        <h5>Development tools</h5>

        <div class="form-inline my-2">
          <button class="btn btn-primary" @click="showResultModal">Show Result Modal</button>
        </div>
      </div>
    </div>

    <!-- MODAL RESULT / START -->
    <basic-modal :modal-id="modal.id" :modal-class="modal.class_name" class="modal-reward-form" :show="modal.show"
                 v-on:modalClose="modal.show = false">


      <div class="modal-body text-center">
        <div class=" p-2 reward-gift-icon">
          <IconGiftOpen/>
        </div>
        <h3 class="font-weight-bold mt-4">{{ __('Congratulazioni') }}</h3>

        <div class="mt-4">

          <p>
            {{ __('Il tuo premio ') }} <strong> {{ current_contest_rewards_name }} </strong>
            {{ __(' sta per arrivare all\'indirizzo da te indicato') }}<br>
            {{
              __('A breve riceverai un\'e-mail con la conferma della tua richiesta e informazioni utili per l\'utilizzo del tuo premio.')
            }}
          </p>


          <div class="d-inline-block border border-secondary border-2px text-uppercase p-1 mb-4"
               v-if="!pre_release && playData.badgeAcquired">
            {{ __('Hai ottenuto') }}
            <IconBadge class="icon-badge-sm "/>
            <strong>{{ playData.badgeAcquired }} {{ __('Badge') }}</strong>
          </div>


          <div class="mb-5">
            <a class="btn btn-primary btn-lg" :href="contestsUrl">{{ __('Chiudi') }}</a>
          </div>

        </div>

      </div>
      <div class="bg-dark p-5" v-if="showNewsletter && user.flg_privacy_mail != '1'">
        <NewsletterBox/>
      </div>


    </basic-modal>
    <!-- MODAL RESULT / END -->


    <!-- MODAL ERROR / BEGIN -->
    <ErrorModal :error="error" v-on:modalClose="error = null"/>
    <!-- MODAL ERROR / END -->


  </div>
</template>

<script>

/* eslint-disable */


import _             from 'lodash';
import $             from 'jquery';
import TimPartyMixin from '../mixins/TimPartyMixin';

import LoaderOverlay from './LoaderOverlay.vue'
import NewsletterBox from './NewsletterBox.vue';
import BasicModal    from './BasicModal.vue'
import ErrorModal    from './ErrorModal.vue'


import IconGiftOpen from '../assets/images/icon-gift-open.svg';
import IconBadge    from '../assets/images/icon-badge.svg';


import ListItalianDistricts from '../assets/data/italian_districts.js';
import ListCountries        from '../assets/data/countries.js';

export default {
  name: 'InstantWinRewardForm',
  mixins: [TimPartyMixin],
  components: {LoaderOverlay, BasicModal, ErrorModal, IconGiftOpen, IconBadge, NewsletterBox},
  props: {
    accessToken: String,
    apiUrl: String,
    userId: Number,
    playData: String,
    // contestId: String,
    contestCode: String,
    showNewsletter: {
      type: Boolean,
      default: true
    },
    contestsUrl: {
      type: Boolean,
      default: '/gioca-e-vinci'
    }

  },
  data: function () {

    return {
      loading: false,

      current_contest: null,

      form_sections: {
        email: false,
        shipping: false,
        id: false
      },

      current_state: 'form',


      userdata: {
        email: '',
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        province: '',
        zipCode: '',
        country: 'IT',
        careOf: '',
        deliveryNote: '',
        phone: '',
        privacy_consent: false,
        id: {
          name: '',
          surname: '',
          documentNumber: '',
          documentType: '',
          municipalityRelease: '',
          releaseDate: '',
          validityDate: ''

        }
      },


      id_types: [
        {code: 'CI', label: 'Carta d\'identità'},
        {code: 'PA', label: 'Patente'},
        {code: 'PS', label: 'Passaporto'}
      ],


      selectedFile: null,
      idFilename: null,


      modal: {
        id: 'modal-reward-form',
        show: false,
        class_name: 'modal-lg'

      },


      validation_errors: {
        email: false,
        firstName: false,
        lastName: false,
        address: false,
        city: false,
        province: false,
        zipCode: false,
        country: false,
        careOf: false,
        deliveryNote: false,
        phone: false,
        privacy_consent: false,

        id_name: false,
        id_surname: false,
        id_documentNumber: false,
        id_documentType: false,
        id_municipalityRelease: false,
        id_releaseDate: false,
        id_validityDate: false

      },

      italian_districts: null,
      countries: null
    };
  },
  mounted: function () {
    var self = this;

    this.setApiUrl(this.apiUrl);


    this.getContest(function () {

      if (self.playData != undefined && self.playData.rewards != undefined && self.playData.rewards.length > 0) {
        for (var i in self.playData.rewards) {
          var reward = self.playData.rewards[i];

          if (reward.reward.deliveryType != undefined && reward.reward.deliveryType == 'Shipping') {
            self.form_sections.shipping = true;
          }
          else if (reward.reward.deliveryType != undefined && reward.reward.deliveryType == 'Voucher') {
            self.form_sections.email = true;
          }
        }
      }
    });

    this.italian_districts = ListItalianDistricts;
    this.countries         = ListCountries;

  },

  methods: {


    getContest: function (callback) {

      var self = this;


      var payload = {
        action: 'get',
        access_token: this.accessToken,
        contest_code: this.contestCode
      };

      this.loading = true;

      this.callApiGet(payload, function (response) {

        self.loading         = false;
        self.current_contest = response.data;

        if (callback) {
          callback();
        }

      });
    },


    /*

    triggerFileInput: function(){
      $('#id-attachment-input').trigger('click');
    },


    handleFileChange: function( e ){
      this.selectedFile = e.target.files[0];

      var errors = [];

      var ext = this.getFileExtension( this.selectedFile.name ).toLowerCase();
      var valid_extensions = [ 'jpg', 'jpeg', 'png', 'pdf'];

      if( valid_extensions.indexOf(ext) == -1 )
        errors.push( this.__('Formato non valido') );

      var max_size = 5 * 1024 * 1024; // 5mb max filesize

      if( this.selectedFile.size > max_size )
        errors.push( this.__('Il file supera la dimensione massima consentita (5Mb)') );

      if( errors.length > 0){
        e.target.value = null;
        this.showError( this.__('Errore'), errors.join('<br>') )
        this.selectedFile = null;
        return;
      }


      var postData= new FormData()

      postData.append('action', 'uploadId');
      postData.append('access_token', this.accessToken);
      postData.append('contest_id', this.current_contest.id);
      postData.append('id_attachment', this.selectedFile, this.selectedFile.name);

      var self = this;

      $.ajax({
          url: this.apiUrl,
          data: postData,
          processData: false,
          contentType: false,
          type: 'POST',
          success: function ( data ) {

            if( data.success && data.filename != undefined ){
              self.selectedFile = null;
              self.idFilename = data.filename;
            }
          }
      });




    },

    */

    validateForm: function () {

      var result = true;


      // EMAIL

      if (!this.checkEmail(this.userdata.email)) {
        result                          = false;
        this.validation_errors['email'] = true;
      }
      else {
        this.validation_errors['email'] = false;
      }

      // PRIVACY CONSENT

      if (!this.userdata.privacy_consent) {
        result                                    = false;
        this.validation_errors['privacy_consent'] = true;
      }
      else {
        this.validation_errors['privacy_consent'] = false;
      }

      // DEFAULT FIELDS

      var standard_fields = ['firstName', 'city'];

      if (this.form_sections.shipping) {
        standard_fields = standard_fields.concat(['lastName', 'address', 'zipCode', 'province', 'country']);
      }

      for (var i in standard_fields) {
        var field = standard_fields[i];
        if (field == 'zipCode' && !parseInt(this.userdata[field])) {
          result                        = false;
          this.validation_errors[field] = true;
        }
        else if (this.userdata[field] == '') {
          result                        = false;
          this.validation_errors[field] = true;
        }
        else {
          this.validation_errors[field] = false;
        }

      }

      // ID FIELDS

      if (this.idRequired) {

        var id_fields = ['name', 'surname', 'documentNumber', 'documentType', 'municipalityRelease', 'releaseDate', 'validityDate'];

        for (var i in id_fields) {
          var field = id_fields[i];

          if (this.userdata.id[field] == '') {
            result                                = false;
            this.validation_errors['id_' + field] = true;
          }
          else {
            this.validation_errors['id_' + field] = false;
          }

        }
      }

      return result;
    },


    submitForm: function () {

      if (!this.validateForm()) {

        this.modal.show = false;
        this.showError('Errore nella compilazione del modulo', 'Si prega di verificare i campi indicati');
        return;
      }

      var self = this;

      var rewards = this.playData.rewards != undefined ? _.filter(this.playData.rewards, {status: 'NAP'}) : {};

      rewards = [rewards[0]]; // TODO: remove, only for test


      // DEPRECATED
      rewards = rewards.map(function (item) {
        if (item.reward.deliveryType != undefined) {
          item.reward.prodType = item.reward.deliveryType;

        }
        return item;
      });


      var payload = {
        action: 'updateInfos',
        access_token: this.accessToken,
        update_data: {

          action: 'update',
          loyaltyLine: this.userId,

          email: this.userdata.email,
          cognome: this.userdata.lastName,
          nome: this.userdata.firstName,
          indirizzo: this.userdata.address,
          cap: this.userdata.zipCode,
          citta: this.userdata.city,
          provincia: this.userdata.province,
          //stato: this.userdata.country,
          note: this.userdata.deliveryNote,
          telefonoAlternativo: this.userdata.phone,

          flagConsenso: this.userdata.privacy_consent,
          consenso: this.userdata.privacy_consent ? 'S' : 'N',

          // filter rewards sending only the ones in NAP status
          rewards: rewards
        }

      };

      //if(this.idRequired == true){
      payload.update_data.acceptance = this.userdata.id;
      //}

      console.log(payload);


      this.loading = true;
      this.callApi(payload, function (response) {
        console.log(response);

        self.loading = false;

        if (!response.success) {
          self.current_state = null;

          var error = response.data.errorMessage != undefined ? response.data.errorMessage : response.data;

          self.showError(error);
        }
        else {
          self.modal.show       = true;
          self.modal.class_name = "modal-lg";
          self.current_state    = 'result';
        }


      });
    },


    showResultModal: function () {
      this.modal.show       = true;
      this.modal.class_name = "modal-lg";
      this.current_state    = 'result';
    }


  },
  computed: {
    formAvailable: function () {
      return this.current_contest ? true : false;
    },


    current_contest_rewards_name: function () {
      if (_.has(this, 'playData.rewards') && this.playData.rewards.length > 0) {
        return _.map(this.playData.rewards, function (item) {
          return item.reward.name;
        }).join(', ');
      }
      else {
        return null;
      }
    },

    idRequired: function () {

      var required = false;

      if (this.playData && this.playData.rewards != undefined) {
        for (var i in this.playData.rewards) {
          var r = this.playData.rewards[i];
          if (r.reward.acceptanceNeeded == 'true' || r.reward.acceptanceNeeded === true) {
            required = true;
          }
        }
      }

      return required;

    },


    pre_release: function () {
      return true;
    },
  },
}
</script>


